import { Children, isValidElement } from 'react';

/**
 * Filter out invalid children from a React component.
 * @param {React.ReactNode=} children - children to filter
 * @returns {React.ReactElement<unknown>[]} - filtered children
 */
export const onlyValidChildren = (children) => {
  return Children.toArray(children).filter(isValidElement);
};

/**
 * Share a React ref between two refs
 * @param {React.Ref} refA - React ref
 * @param {React.Ref} refB - React ref
 * @returns {React.RefCallback} - React ref callback
 */
export const shareReactRef = (refA, refB) => (instance) => {
  if (typeof refA === 'function') {
    refA(instance);
  } else if (refA) {
    refA.current = instance;
  }

  if (typeof refB === 'function') {
    refB(instance);
  } else if (refB) {
    refB.current = instance;
  }
};
